import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewConsultaCaravana = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'consulta_caravana',
        name: 'Consultar por Caravana',
        component: ViewConsultaCaravana,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
